"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_BUFFER_TIME = exports.REFRESH_TOKEN_DURATION = exports.ID_TOKEN_DURATION = exports.ACCESS_TOKEN_DURATION = exports.PRM_ID_CLAIM = exports.TOKEN_USE_CLAIM = exports.EXP_CLAIM = exports.SESSION_STORAGE_AUTH_CODE_KEY = exports.SESSION_STORAGE_EXPIRES_IN_KEY = exports.SESSION_STORAGE_TOKEN_TYPE_KEY = exports.SESSION_STORAGE_ID_TOKEN_KEY = exports.SESSION_STORAGE_REFRESH_TOKEN_KEY = exports.SESSION_STORAGE_ACCESS_TOKEN_KEY = exports.SESSION_STORAGE_CODE_VERIFIER_KEY = void 0;
exports.SESSION_STORAGE_CODE_VERIFIER_KEY = 'code_verifier';
exports.SESSION_STORAGE_ACCESS_TOKEN_KEY = 'access_token';
exports.SESSION_STORAGE_REFRESH_TOKEN_KEY = 'refresh_token';
exports.SESSION_STORAGE_ID_TOKEN_KEY = 'id_token';
exports.SESSION_STORAGE_TOKEN_TYPE_KEY = 'token_type';
exports.SESSION_STORAGE_EXPIRES_IN_KEY = 'expires_in';
exports.SESSION_STORAGE_AUTH_CODE_KEY = 'auth_code';
// JWT claims
exports.EXP_CLAIM = "exp";
exports.TOKEN_USE_CLAIM = "token_use";
exports.PRM_ID_CLAIM = "prmId";
// FIT token duration times
exports.ACCESS_TOKEN_DURATION = 900; // 900 sec. = 15 min.
exports.ID_TOKEN_DURATION = 3600; // 3,600 sec. = 60 min. = 1 hr.
exports.REFRESH_TOKEN_DURATION = 28800; // 28,800 sec. = 480 min. = 8 hr.
exports.TOKEN_BUFFER_TIME = 300; // 300 sec. = 5 min.
//# sourceMappingURL=constants.js.map